$(document).on("turbolinks:load", function() {
  $.$behavior.to('.merge_customers', function() {
    $(document).on('change', '[id^=merge_options_]', function () {
      var parent = $(this).parent().parent();
      parent.children('.value_target')[0].classList.toggle('selected_value');
      parent.children('.value_source')[0].classList.toggle('selected_value');
    });
  });
});
